// extracted by mini-css-extract-plugin
export var contact = "hero-module--contact--NtoFG";
export var cursor = "hero-module--cursor--Dx8td";
export var logo = "hero-module--logo--Oqg9O";
export var text = "hero-module--text--odAtS";
export var ttext = "hero-module--ttext--8cKAa";